module.exports = __webpack_public_path__ + "resources/img/career-welfareImg8.8062b013.jpg";